import { AlarmTableViewMeta } from './types';

export const alarmTableViews: AlarmTableViewMeta[] = [
  {
    id: 'unacknowledged-alarms',
    name: 'Unacknowledged',
  },
  {
    id: 'acknowledged-alarms',
    name: 'Acknowledged',
  },
];
